/* WKOŁO – półka książek (sekcja wkolo-regal): okładki na półce albo grzbiety.
   Klik w okładkę otwiera okienko z podglądem książki (książka 3D, fragmenty, początek opisu, koszyk); klik w cenę prowadzi do książki.
   Tryb grzbietów: klik w grzbiet: książka obraca się okładką do przodu (najwyżej N naraz, najdawniej wysunięta wraca).
   Strzałka ↩ odkłada ją na półkę. Metka z ceną to zwykły link do książki.
   Wymiary w mm: z bloku (data-dims) albo z opisu produktu (format, liczba stron, oprawa).
   Zdjęcia produktów z tłem makiety są przycinane do samej okładki (canvas). */
(function () {
  'use strict';

  var MM_PER_PAGE = 0.075;           // papier ~100 g/m², vol. 1,5 (np. Munken Print White)
  var FORMATS = { A4: [210, 297], A5: [148, 210], B5: [176, 250], B6: [125, 176] };
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function num(s) {
    var m = String(s || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }

  // wymiary książki w mm: [szerokość, wysokość, grubość, czy znany format]
  function bookSize(b, aspect) {
    var d = b.getAttribute('data-dims');
    if (d) {
      var p = d.toLowerCase().split(/\s*[x×]\s*/).map(num);
      if (p.length === 3 && p[0] && p[1] && p[2]) return [p[0], p[1], p[2], true];
    }
    var bind = (b.getAttribute('data-binding') || '').toLowerCase();
    var hard = /tward/.test(bind);
    var pages = num(b.getAttribute('data-pages'));
    var f = b.getAttribute('data-format') || '';
    var w = 0, h = 0, m;
    if ((m = f.match(/(\d{2,3}(?:[.,]\d)?)\s*[x×]\s*(\d{2,3}(?:[.,]\d)?)\s*(mm|cm)?/i))) {
      w = num(m[1]); h = num(m[2]);
      if ((m[3] || '').toLowerCase() === 'cm' || h < 40) { w *= 10; h *= 10; }
    } else if ((m = f.match(/\b(A4|A5|B5|B6)(?![0-9])/i))) {
      w = FORMATS[m[1].toUpperCase()][0]; h = FORMATS[m[1].toUpperCase()][1];
    }
    var known = !!(w && h);
    if (!known) { h = hard ? 240 : 235; w = Math.round(h * (aspect || 0.7)); }
    if (hard && known) { w += 4; h += 6; }
    var t = pages ? pages * MM_PER_PAGE + (hard ? 5 : 0.6) : (hard ? 24 : 18);
    return [w, h, Math.round(t * 10) / 10, known];
  }

  // przycięcie tła makiety: ramka obszaru różniącego się od koloru narożników
  function trimBox(img) {
    var c = document.createElement('canvas');
    var cw = 120, ch = Math.max(1, Math.round(cw * img.naturalHeight / img.naturalWidth));
    c.width = cw; c.height = ch;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, cw, ch);
    var px = ctx.getImageData(0, 0, cw, ch).data;   // rzuca wyjątek, gdy obrazek bez CORS
    function at(x, y) { var i = (y * cw + x) * 4; return [px[i], px[i + 1], px[i + 2]]; }
    var cs = [at(1, 1), at(cw - 2, 1), at(1, ch - 2), at(cw - 2, ch - 2)];
    var bg = [0, 1, 2].map(function (k) { return cs.map(function (q) { return q[k]; }).sort(function (a, b) { return a - b; })[1]; });
    function diff(x, y) { var q = at(x, y); return Math.abs(q[0] - bg[0]) + Math.abs(q[1] - bg[1]) + Math.abs(q[2] - bg[2]) > 40; }
    var cols = [], rows = [], x, y, n;
    for (x = 0; x < cw; x++) { n = 0; for (y = 0; y < ch; y++) if (diff(x, y)) n++; cols.push(n / ch); }
    for (y = 0; y < ch; y++) { n = 0; for (x = 0; x < cw; x++) if (diff(x, y)) n++; rows.push(n / cw); }
    function first(a, lim) { for (var i = 0; i < a.length; i++) if (a[i] > lim) return i; return -1; }
    function last(a, lim) { for (var i = a.length - 1; i >= 0; i--) if (a[i] > lim) return i; return -1; }
    var x0 = first(cols, 0.5), x1 = last(cols, 0.5), y0 = first(rows, 0.5), y1 = last(rows, 0.5);
    if (x0 < 0 || y0 < 0 || x1 - x0 < cw * 0.3 || y1 - y0 < ch * 0.3) return null;
    var box = { x0: (x0 + 0.5) / cw, y0: (y0 + 0.5) / ch, x1: (x1 + 0.5) / cw, y1: (y1 + 0.5) / ch };
    if (box.x0 < 0.02 && box.y0 < 0.02 && box.x1 > 0.98 && box.y1 > 0.98) box = { x0: 0, y0: 0, x1: 1, y1: 1 };
    // kolor grzbietu: średnia z pasa przy lewej krawędzi okładki
    var r = 0, g = 0, bl = 0, k = 0;
    var sx0 = Math.round(cw * (box.x0 + (box.x1 - box.x0) * 0.04)), sx1 = Math.round(cw * (box.x0 + (box.x1 - box.x0) * 0.22));
    for (y = Math.round(ch * box.y0); y < Math.round(ch * box.y1); y += 2) {
      for (x = sx0; x < sx1; x += 2) { var q = at(x, y); r += q[0]; g += q[1]; bl += q[2]; k++; }
    }
    box.color = k ? [r / k, g / k, bl / k].map(Math.round) : null;
    return box;
  }

  function size(b) {
    var s = bookSize(b, b.__aspect);
    b.style.setProperty('--w', s[0]); b.style.setProperty('--h', s[1]); b.style.setProperty('--t', s[2]);
    b.__known = s[3];
  }

  // przycięcie tła makiety i kolor grzbietu z okładki; onShape() gdy zmieniły się proporcje książki
  function prepare(b, onShape) {
    var img = b.querySelector('img');
    var spine = b.querySelector('.bk__spine:not(.bk__spine--img)');
    var needColor = spine && !spine.hasAttribute('data-spine-set');
    if (!img || (!b.hasAttribute('data-trim') && !needColor)) return;
    function run() {
      var box = null;
      try { box = trimBox(img); } catch (e) { return; }
      if (!box) return;
      if (b.hasAttribute('data-trim') && (box.x1 - box.x0 < 0.999 || box.y1 - box.y0 < 0.999)) {
        var bw = box.x1 - box.x0, bh = box.y1 - box.y0;
        img.style.setProperty('--iw', (100 / bw) + '%');
        img.style.setProperty('--ih', (100 / bh) + '%');
        img.style.setProperty('--ix', (-100 * box.x0 / bw) + '%');
        img.style.setProperty('--iy', (-100 * box.y0 / bh) + '%');
        img.classList.add('is-trimmed');
        b.__aspect = (bw * img.naturalWidth) / (bh * img.naturalHeight);
      } else {
        b.__aspect = img.naturalWidth / img.naturalHeight;
      }
      if (needColor && box.color) {
        var c = box.color, lum = 0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2];
        spine.style.setProperty('--c', 'rgb(' + c.join(',') + ')');
        spine.style.setProperty('--tc', lum > 150 ? '#111111' : '#ffffff');
      }
      if (onShape.always || !b.__known) { if (!onShape.always) size(b); onShape(); }
    }
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  }


  // ---------- okienko z podglądem książki (klik w okładkę) ----------
  // Od razu: tytuł, autor, 1–2 zdania i cena z półki (.wk-info). Potem z /products/{handle}?view=podglad
  // (szablon product.podglad): książka 3D lub okładka z „Zajrzyj do środka” / „Posłuchaj fragmentu”, początek opisu
  // ze szczegółami i „Dodaj do koszyka”. wkolo-ksiazka.js/css (książka 3D, czytnik, skracanie opisu) dochodzą przy pierwszym otwarciu.
  var SALES = /zam[óo]w|wysy[łl]k|kup (teraz|ju[żz])|sprawd[źz] |kliknij|do koszyka|dost[ęe]pn[ae] od r[ęe]ki/i;
  var pv = null, pvOwner = null, pvTrigger = null, pvTimer, pvSeq = 0, pvAssets = null;

  // 1–2 zdania: bez nagłówków i etykiet (krótkie fragmenty bez kropki) i bez zdań sprzedażowych
  function shortText(raw) {
    var segs = String(raw || '').split('|').map(function (x) { return x.replace(/\s+/g, ' ').trim(); })
      .filter(function (x) { return x && !(x.length < 70 && !/[.!?…]["”»]?$/.test(x)); });
    var text = segs.join(' ');
    var sents = text.match(/[^.!?…]+[.!?…]+["”»]?/g) || (text ? [text] : []);
    var out = [], len = 0;
    for (var i = 0; i < sents.length && out.length < 2; i++) {
      var z = sents[i].trim();
      if (!z || SALES.test(z)) continue;
      if (out.length && len + z.length > 260) break;
      out.push(z); len += z.length;
      if (len >= 150) break;
    }
    var r = out.join(' ') || text;
    return r.length > 300 ? r.slice(0, 297).replace(/\s+\S*$/, '') + '…' : r;
  }

  function loadAssets(shelf) {
    if (pvAssets) return pvAssets;
    function load(tag, attrs) {
      return new Promise(function (res) {
        var e = document.createElement(tag);
        Object.keys(attrs).forEach(function (k) { e[k] = attrs[k]; });
        e.onload = res; e.onerror = res;
        document.head.appendChild(e);
      });
    }
    var css = shelf.getAttribute('data-pv-css'), js = shelf.getAttribute('data-pv-js');
    pvAssets = Promise.all([
      css ? load('link', { rel: 'stylesheet', href: css }) : null,
      js && !window.wkKsiazka ? load('script', { src: js }) : null
    ]);
    return pvAssets;
  }

  function ensurePv() {
    if (pv) return;
    pv = document.createElement('div');
    pv.className = 'wk-pv';
    pv.hidden = true;
    pv.innerHTML =
      '<div class="wk-pv__panel" role="dialog" aria-modal="true" aria-labelledby="wk-pv-title">' +
      '<button class="wk-pv__close" type="button" aria-label="Zamknij">×</button>' +
      '<div class="wk-pv__scroll"><div class="wk-pv__media"></div>' +
      '<div class="wk-pv__info">' +
      '<h2 class="wk-pv__title" id="wk-pv-title"></h2><p class="wk-pv__author"></p>' +
      '<div class="wk-pv__body"></div>' +
      '<div class="wk-pv__buy"><p class="wk-pv__price"></p><div class="wk-pv__cart"></div></div>' +
      '<a class="wk-pv__more" href="#">Pełny opis książki <span aria-hidden="true">→</span></a>' +
      '</div></div></div>';
    document.body.appendChild(pv);
    pv.querySelector('.wk-pv__close').addEventListener('click', function () { closePv(true); });
    pv.addEventListener('click', function (e) { if (e.target === pv) closePv(true); });   // klik w tło
    // w fazie przechwytywania: gdy otwarty jest czytnik fragmentu, Esc zamyka najpierw jego
    window.addEventListener('keydown', function (e) {
      if (!pvOwner || document.querySelector('.wk-reader.is-open')) return;
      if (e.key === 'Escape') closePv(true);
      if (e.key === 'Tab') trapFocus(e);
    }, true);
    // „Dodaj do koszyka” (product-form motywu): okienko się zamyka, motyw otwiera szufladę koszyka
    document.addEventListener('product-ajax:added', function () { if (pvOwner) closePv(false); });
  }

  function trapFocus(e) {
    var f = Array.prototype.filter.call(pv.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'),
      function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  function openPv(owner, trigger) {
    var info = owner.querySelector('.wk-info');
    if (!info) return;
    ensurePv();
    var seq = ++pvSeq;
    function txt(sel) { var el = info.querySelector(sel); return el ? el.textContent.trim() : ''; }
    // tytuł produktu bywa z autorami po myślniku – w okienku autor ma własny wiersz
    var title = txt('.wk-info__title'), author = txt('.wk-info__author'), cut = title.indexOf(' – ');
    if (author && cut > 0 && author.indexOf(title.slice(cut + 3).split(',')[0].trim()) >= 0) title = title.slice(0, cut);
    pv.querySelector('.wk-pv__title').textContent = title;
    var au = pv.querySelector('.wk-pv__author');
    au.textContent = author;
    au.hidden = !author;
    var link = info.querySelector('.wk-info__cta'), url = link ? link.href : '';
    pv.querySelector('.wk-pv__more').href = url || '#';
    var ipEl = info.querySelector('.wk-info__price'); pv.querySelector('.wk-pv__price').innerHTML = ipEl ? ipEl.innerHTML.trim() : '';
    pv.querySelector('.wk-pv__cart').innerHTML = '';
    var body = pv.querySelector('.wk-pv__body'), p = document.createElement('p');
    p.textContent = shortText(txt('.wk-info__text'));
    body.innerHTML = '';
    body.appendChild(p);
    // do czasu wczytania: okładka z półki (zdjęcia przycinane na półce czekają na właściwą okładkę)
    var media = pv.querySelector('.wk-pv__media'), img = owner.querySelector('img');
    media.innerHTML = '';
    if (img && !img.classList.contains('is-trimmed')) {
      var c = document.createElement('div'), im = new Image();
      c.className = 'wk-pv__cover';
      im.src = img.currentSrc || img.src; im.alt = '';
      c.appendChild(im);
      media.appendChild(c);
    }
    pvOwner = owner; pvTrigger = trigger;
    owner.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    clearTimeout(pvTimer);
    pv.hidden = false;
    pv.classList.add('is-loading');
    pv.querySelector('.wk-pv__scroll').scrollTop = 0;
    document.documentElement.classList.add('wk-pv-lock');
    requestAnimationFrame(function () { pv.classList.add('is-open'); });
    pv.querySelector('.wk-pv__close').focus({ preventScroll: true });
    if (!url) { pv.classList.remove('is-loading'); return; }
    Promise.all([
      fetch(url.split(/[?#]/)[0] + '?view=podglad', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }),
      loadAssets(owner.closest('.wk-regal'))
    ]).then(function (res) {
      if (seq === pvSeq) fill(res[0]);
    }).catch(function () {
      if (seq === pvSeq) pv.classList.remove('is-loading');   // zostaje podgląd z półki i link do książki
    });
  }

  // części z szablonu product.podglad: najpierw skrócenie opisu (jeszcze w <template>), potem do okienka
  function fill(html) {
    var K = window.wkKsiazka, t = document.createElement('template');
    t.innerHTML = html;
    function move(name, sel) {
      var from = t.content.querySelector('[data-pv="' + name + '"]'), to = pv.querySelector(sel);
      if (!from) return;
      to.innerHTML = '';
      while (from.firstChild) to.appendChild(from.firstChild);
    }
    if (K) {
      var body = t.content.querySelector('[data-pv="body"]');
      if (body) K.shorten(body);
      move('media', '.wk-pv__media');
      move('body', '.wk-pv__body');
    }
    move('buy', '.wk-pv__cart');
    // wariant (papier / e-book / pakiet): do formularza koszyka i cena wybranego wariantu zamiast „od …”
    var form = pv.querySelector('.wk-pv__form'), price = pv.querySelector('.wk-pv__price');
    Array.prototype.forEach.call(pv.querySelectorAll('.wk-pv__variant input'), function (r) {
      if (r.checked) price.textContent = r.getAttribute('data-price');
      r.addEventListener('change', function () {
        if (form) form.querySelector('[name="id"]').value = r.value;
        price.textContent = r.getAttribute('data-price');
      });
    });
    if (window.customElements && customElements.upgrade) customElements.upgrade(pv);   // form is="product-form"
    if (K) K.init(pv);
    pv.classList.remove('is-loading');
  }

  function closePv(returnFocus) {
    if (!pvOwner) return;
    pvSeq++;
    if (window.wkKsiazka) window.wkKsiazka.stop();
    pvOwner.classList.remove('is-open');
    if (pvTrigger) pvTrigger.setAttribute('aria-expanded', 'false');
    if (returnFocus && pvTrigger && document.body.contains(pvTrigger)) pvTrigger.focus({ preventScroll: true });
    pvOwner = null; pvTrigger = null;
    pv.classList.remove('is-open');
    document.documentElement.classList.remove('wk-pv-lock');
    pvTimer = setTimeout(function () {
      pv.hidden = true;
      pv.querySelector('.wk-pv__media').innerHTML = '';
    }, 250);
  }

  // tryb „okładki na półce”: rzędy po data-cols okładek, deska co rząd (CSS), skala do najszerszych
  function initCovers(shelf) {
    var items = Array.prototype.slice.call(shelf.querySelectorAll('.wk-cv'));
    if (!items.length) return;
    var cols = parseInt(shelf.getAttribute('data-cols'), 10) || 5;
    var uniform = shelf.hasAttribute('data-uniform');
    // jednakowa wysokość: 240 jednostek, szerokość z proporcji okładki (katalog / przycięte zdjęcie)
    function shape(b) {
      if (!uniform) { size(b); return; }
      var a = b.__aspect;
      if (!a) { var s = bookSize(b); a = s[3] ? s[0] / s[1] : 0.7; }
      b.style.setProperty('--h', 240);
      b.style.setProperty('--w', Math.round(240 * a * 10) / 10);
    }
    function fit() {
      var cs = getComputedStyle(shelf);
      var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      var avail = shelf.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var gap = parseFloat(cs.getPropertyValue('--gap')) * rem || 32;
      var widths = [], maxH = 0;
      items.forEach(function (b) {
        widths.push(parseFloat(b.style.getPropertyValue('--w')));
        maxH = Math.max(maxH, parseFloat(b.style.getPropertyValue('--h')));
      });
      var s;
      if (MOBILE.matches) {
        s = 17 * rem / (uniform ? 240 : 256);      // B5 ≈ 17 rem wysokości, w rzędzie widać 2,5 okładki
      } else {
        widths.sort(function (a, b) { return b - a; });
        var n = Math.min(cols, widths.length), sum = 0;
        for (var i = 0; i < n; i++) sum += widths[i];
        s = Math.min(1.1, 28 * rem / (uniform ? 240 : 256), (avail - gap * n) / sum);
      }
      shelf.style.setProperty('--s', s.toFixed(3) + 'px');
      shelf.style.setProperty('--row', Math.ceil(maxH * s + (MOBILE.matches ? 6.2 : 7.6) * rem) + 'px');   // zapas u góry + deska
      // warstwa z deskami na całą szerokość rzędu (na telefonie rząd przewija się w bok)
      shelf.style.removeProperty('--sw');
      shelf.style.setProperty('--sw', shelf.scrollWidth + 'px');
    }
    shelf.addEventListener('click', function (e) {
      var img = e.target.closest('.wk-cv__img');
      if (!img || !shelf.contains(img)) return;
      e.preventDefault();
      openPv(img.closest('.wk-cv'), img);
    });
    items.forEach(function (b) {
      var onShape = function () { shape(b); fit(); };
      onShape.always = uniform;
      shape(b);
      prepare(b, onShape);
    });
    fit();
    var timer;
    window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(fit, 120); });
  }

  function init(shelf) {
    if (!shelf || shelf.__wkRegal) return;
    shelf.__wkRegal = true;
    if (shelf.classList.contains('wk-regal--covers')) { initCovers(shelf); return; }
    var books = Array.prototype.slice.call(shelf.querySelectorAll('.bk'));
    if (!books.length) return;
    var maxDesk = parseInt(shelf.getAttribute('data-max'), 10) || 3;
    var maxMobile = parseInt(shelf.getAttribute('data-max-mobile'), 10) || 1;
    function max() { return MOBILE.matches ? maxMobile : maxDesk; }
    var shown = books.filter(function (b) { return !b.classList.contains('is-spine'); });

    function label(b) {
      var t = b.getAttribute('data-title');
      var spine = b.classList.contains('is-spine');
      var hit = b.querySelector('.bk__hit');
      hit.setAttribute('aria-label', (spine ? 'Pokaż okładkę: ' : 'Podgląd książki: ') + t);
      if (spine) hit.removeAttribute('aria-haspopup'); else hit.setAttribute('aria-haspopup', 'dialog');
      var undo = b.querySelector('.bk__undo');
      if (undo) undo.tabIndex = spine ? -1 : 0;
      var tag = b.querySelector('.wk-tag');
      if (tag) tag.tabIndex = spine ? -1 : 0;
    }

    function limit() {
      while (shown.length > max()) {
        var old = shown.shift();
        old.classList.add('is-spine'); label(old);
      }
    }

    // skala px/mm: wszystkie grzbiety + max() najszerszych okładek mieszczą się na półce
    function fit() {
      var cs = getComputedStyle(shelf);
      var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      var avail = shelf.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var spineGap = (MOBILE.matches ? 0.16 : 0.3) * rem;
      var gap = (parseFloat(cs.getPropertyValue('--mL')) + parseFloat(cs.getPropertyValue('--mR'))) * rem;
      var mm = 0, px = 0, widths = [];
      books.forEach(function (b) {
        var w = parseFloat(b.style.getPropertyValue('--w')), t = parseFloat(b.style.getPropertyValue('--t'));
        mm += t; px += spineGap; widths.push(w - t);
      });
      widths.sort(function (a, b) { return b - a; });
      for (var i = 0; i < Math.min(max(), widths.length); i++) { mm += widths[i]; px += gap - spineGap; }
      if (!shelf.classList.contains('wk-regal--plank')) px += (MOBILE.matches ? 5.2 : 8.4) * rem;
      var s = Math.max(0.25, Math.min(1.25, (avail - px) / mm));
      shelf.style.setProperty('--s', s.toFixed(3) + 'px');
    }

    books.forEach(function (b, i) {
      b.style.setProperty('--z', books.length - i);
      size(b);
      label(b);
      prepare(b, fit);
    });
    // na telefonie z kilku wybranych okładek zostaje środkowa, nie ostatnia
    if (shown.length > max()) {
      var from = Math.floor((shown.length - max()) / 2), keep = shown.slice(from, from + max());
      shown.forEach(function (b) { if (keep.indexOf(b) < 0) { b.classList.add('is-spine'); label(b); } });
      shown = keep;
    }
    fit();

    shelf.addEventListener('click', function (e) {
      var undo = e.target.closest('.bk__undo');
      var hit = e.target.closest('.bk__hit');
      if (undo && shelf.contains(undo)) {                 // ↩ odłóż na półkę
        var u = undo.closest('.bk');
        u.classList.add('is-spine');
        shown = shown.filter(function (x) { return x !== u; });
        label(u);
        u.querySelector('.bk__hit').focus({ preventScroll: true });
        return;
      }
      if (!hit || !shelf.contains(hit)) return;
      var b = hit.closest('.bk');
      if (b.classList.contains('is-spine')) {             // grzbiet: obróć okładką do przodu
        b.classList.remove('is-spine');
        shown.push(b);
        limit();
        label(b);
      } else {                                            // okładka: okienko z podglądem
        openPv(b, hit);
      }
    });

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { limit(); fit(); }, 120);
    });
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.wk-regal'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
